import DynamicInterlinking from '@components/DynamicInterlinking/DynamicInterlinking'

import dynamic from 'next/dynamic'

export const RELATION_VS_COMPONENTS = {
  'relation.product-page-accordian': dynamic(() => import('@components/Accordian/Accordian'), { ssr: true }),
  'relation.pp-compare-cards': dynamic(() => import('@components/ValueCompareCardsInGrid'), { ssr: true }),
  'relation.product-page-info-block': dynamic(() => import('@components/InfoHighlightGrid'), { ssr: true }),
  'relation.product-page-swc': dynamic(() => import('@components/OneColumnWidth/onecolumnwidth'), { ssr: true }),
  'relation.pp-jmd': dynamic(() => import('@components/JoinMillions/joinMillion'), { ssr: true }),
  'relation.product-page-table': dynamic(() => import('@components/Table/table'), { ssr: true }),
  'relation.pp-video': dynamic(() => import('@components/Video/Video'), { ssr: true }),
  'relation.product-page-n-grid': dynamic(() => import('@components/NColumnGrid/NColumnGrid'), { ssr: true }),
  'relation.product-page-n-step': dynamic(() => import('@components/StepCards2Column/stepCards2Column'), { ssr: true }),
  'relation.product-page-di': DynamicInterlinking,
  'relation.product-page-quote': dynamic(() => import('@components/Quote/renderQuote'), { ssr: true }),
  'relation.product-page-author': dynamic(() => import('@components/Author/author'), { ssr: true }),
  'relation.product-page-author-new': dynamic(() => import('@components/Author/author'), { ssr: true }),
  'relation.product-page-grw': dynamic(() => import('@components/GoogleRating/googleRating'), { ssr: true }),
  'relation.pp-testimonial': dynamic(() => import('@components/Testimonial/testimonial'), { ssr: true }),
  'relation.product-bullet': dynamic(() => import('@components/BulletCard/bulletCard'), { ssr: true }),
  'relation.product-sticker': dynamic(() => import('@components/StickerCard/stickerCard'), { ssr: true }),
}

export const widgetsProductType = {
  'travel-seo-widget': 'Travel',
  'travel-sem-widget': 'Travel',
  'health-seo-widget': 'Retail health',
  'life-seo-widget': 'Life',
  'car-seo-widget': 'auto-car',
  'bike-seo-widget': 'auto-bike',
  'abha-seo-widget': 'ABHA',
  'multi-product-widget': 'Car/Bike widget',
  'rto-vehicle-info-widget': 'SEO_vehicle_information',
  'rto-widget': 'SEO_RTO',
  'fastag-widget-landing-page': 'SEO_FASTag',
  'hsrp-widget-landing-page': 'SEO_HSRP',
}
